/** AXA TEMPLATE PACKAGE *************************************************/
var axa = axa || (function () {
    return {};
})();

/*** SESSION TIMEOUT MANAGEMENT - SUB AXA PACKAGE ************************/
axa.sessionTimeout = axa.sessionTimeout || (function () {

    /* ----- Private variables and methods ---- */

    var sessionTimeoutDelay = 0;
    var ajaxPingUrl = "";
    var ajaxLogOffUrl = "";
    var logOnUrl = "";
    var marginDelay = 5 * 1000; // 5 s
    var keepAliveDelay = 3 * 60 * 1000; // 3 mn 
    var alertDelay = 60 * 1000; // 1 mn
    var countDownNbOfSeconds = 0;
    var countDownNbOfRemainingSeconds = 0;
    var lastActivityDate = new Date();
    var countDownJsTimeout;
    var checkActivityJsTimeout;
    var LOCALSTORAGEKEY_TIMEOUT_DATE_TIME = 'axa-sessionTimeout.timeoutDateTime';
    var LOCALSTORAGEKEY_START_COUNTDOWN_FLAG = 'axa-sessionTimeout.startCountDownFlag';
    var LOCALSTORAGEKEY_STOP_COUNTDOWN_FLAG = 'axa-sessionTimeout.stopCountDownFlag';
    var LOCALSTORAGEKEY_LOGOFF_FLAG = 'axa-sessionTimeout.logOffFlag';
    var prefixForLocalStorageKey = '';
    var isLoggedOff = false;

    var updateLastActivityDate = function () {
        lastActivityDate = new Date();
    };

    var pingServer = function () {
        $.ajax({
            type: "POST",
            url: ajaxPingUrl,
            success: function () { },
            error: function () { }
        });
    };

    var getAndSendTimeoutDate = function () {

        var nowDate = new Date();

        var localTimeoutDate = new Date(lastActivityDate.getTime() + sessionTimeoutDelay);

        var timeoutDate = localTimeoutDate;
        if (window.localStorage) {
            // We use localStorage instead of cookie because localStorage is supported since IE8
            // and because it avoid sending of unnecessary data throw the network.

            // Get the shared timeout datetime that may have been set by other windows (or this one)
            var sharedTimeoutDateTime = localStorage.getItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_TIMEOUT_DATE_TIME);
            if (sharedTimeoutDateTime) {
                // ... it has been set ...
                sharedTimeoutDate = new Date(parseInt(sharedTimeoutDateTime, 10));
                if (sharedTimeoutDate > timeoutDate) {
                    // ... keep the max date
                    timeoutDate = sharedTimeoutDate;
                }
            }
            // We share the timeout datetime with other windows using localStorage
            localStorage.setItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_TIMEOUT_DATE_TIME, '' + timeoutDate.getTime());
        }

        return timeoutDate;
    }

    var startCheckActivity = function () {
        if (!isLoggedOff && !checkActivityJsTimeout) {
            // If not logged of and not already running => start check
            checkActivityJsTimeout = setTimeout(
                checkActivity,
                0
            );
        }
    };

    var stopCheckActivity = function () {
        if (checkActivityJsTimeout) {
            clearTimeout(checkActivityJsTimeout);
            checkActivityJsTimeout = null;
        }
    };

    var checkActivity = function () {

        var nowDate = new Date();
        var timeoutDate = getAndSendTimeoutDate();

        if (nowDate >= new Date(timeoutDate.getTime() - alertDelay - marginDelay)) {
            // The timeout is imminent...
            stopCheckActivity();
            startCountDown();
            sendStartCountDownSignalToOtherWindows();
        }
        else {
            pingServer();
            // RMQ: 
            //  We don't check and ping again just before the timeout but frequently (keepAliveDelay) 
            // to avoid session lost or authentication timeout coming from a obscure IIS configuration
            // parameter. F*ck Microsoft ! 
            checkActivityJsTimeout = setTimeout(
                checkActivity,
                Math.min(
                    keepAliveDelay,
                    Math.max(0, timeoutDate.getTime() - nowDate.getTime() - alertDelay - marginDelay)
                )
            );
        }
    };

    var startCountDown = function () {

        if (!isLoggedOff && !countDownJsTimeout) {
            // If not logged of and not already running

            // Show counter and overlay
            $("#axa-sessionTimeout-counterDialog").modal('show');

            var nowDate = new Date();
            var timeoutDate = getAndSendTimeoutDate();

            countDownNbOfSeconds = Math.round(Math.max(0, Math.min(alertDelay, timeoutDate.getTime() - nowDate.getTime() - marginDelay)) / 1000);
            countDownNbOfRemainingSeconds = countDownNbOfSeconds;
            countDownJsTimeout = setTimeout(countDown, 0);
        }
    }

    var stopCountDown = function () {

        $("#axa-sessionTimeout-counterDialog").modal('hide');

        if (countDownJsTimeout) {
            clearTimeout(countDownJsTimeout);
            countDownJsTimeout = null;
        }
    }

    var countDown = function () {

        if (countDownNbOfRemainingSeconds <= 0) {
            stopCountDown();
            logOff();
        }
        else {

            var progressPerCent = Math.round(100 * countDownNbOfRemainingSeconds / countDownNbOfSeconds);

            $("#axa-sessionTimeout-counterDialog .progress")
                    .css('width', progressPerCent + '%')
                    .attr('aria-valuenow', progressPerCent);

            // Decrease counter
            countDownNbOfRemainingSeconds--;
            countDownJsTimeout = setTimeout(countDown, 1000);
        }
    }

    var keepAliveProcess = function () {
        pingServer();
        setTimeout(keepAliveProcess, keepAliveDelay);
    };

    var logOffLocal = function () {
        isLoggedOff = true;

        stopCountDown();
        stopCheckActivity();

        // Hide all other Bootstrap modals or the user will be able to interact with them
        $('.modal').modal('hide');
        // Show expiry popup
        $("#axa-sessionTimeout-expiryDialog").modal('show');
    };

    var logOff = function () {
        $.ajax({
            type: "POST",
            url: ajaxLogOffUrl
        });
        logOffLocal();
        sendLogOffSignalToOtherWindows();
    };

    var sendLogOffSignalToOtherWindows = function () {
        if (window.localStorage) {
            localStorage.setItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_LOGOFF_FLAG, "1");
            localStorage.setItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_LOGOFF_FLAG, "0");
        }
    };

    var sendStartCountDownSignalToOtherWindows = function () {
        getAndSendTimeoutDate(); // To force update on other windows
        if (window.localStorage) {
            localStorage.setItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_START_COUNTDOWN_FLAG, "1");
            localStorage.setItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_START_COUNTDOWN_FLAG, "0");
        }
    };

    var sendStopCountDownSignalToOtherWindows = function () {
        getAndSendTimeoutDate(); // To force update on other windows
        if (window.localStorage) {
            localStorage.setItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_STOP_COUNTDOWN_FLAG, "1");
            localStorage.setItem(prefixForLocalStorageKey + LOCALSTORAGEKEY_STOP_COUNTDOWN_FLAG, "0");
        }
    };

    var receiveSignalFromOtherWindows = function (e) {
        if ((prefixForLocalStorageKey + LOCALSTORAGEKEY_STOP_COUNTDOWN_FLAG) === e.originalEvent.key && e.originalEvent.newValue === "1") {
            startCheckActivity();
            stopCountDown();
        }
        if ((prefixForLocalStorageKey + LOCALSTORAGEKEY_START_COUNTDOWN_FLAG) === e.originalEvent.key && e.originalEvent.newValue === "1") {
            stopCheckActivity();
            startCountDown();
        }
        if ((prefixForLocalStorageKey + LOCALSTORAGEKEY_LOGOFF_FLAG) === e.originalEvent.key && e.originalEvent.newValue === "1") {
            logOffLocal();
        }
    };

    return {
        /* ---- Public variables and methods ------ */

        setSessionTimeoutDelay: function (value) {
            sessionTimeoutDelay = value;
        },

        setAjaxPingUrl: function (value) {
            ajaxPingUrl = value;
        },

        setAjaxLogOffUrl: function (value) {
            ajaxLogOffUrl = value;
        },

        setLogOnUrl: function (value) {
            logOnUrl = value;
        },

        setMarginDelay: function (value) {
            marginDelay = value;
        },

        setKeepAliveDelay: function (value) {
            keepAliveDelay = value;
        },

        setAlertDelay: function (value) {
            alertDelay = value;
        },

        setPrefixForLocalStorageKey: function (value) {
            prefixForLocalStorageKey = value;
        },

        startMonitoring: function () {
            if (
                sessionTimeoutDelay === 0
                || ajaxPingUrl === ""
                || ajaxLogOffUrl === ""
                || logOnUrl === ""
            ) {
                alert("[ERROR] sessionTimeoutDelay, ajaxPingUrl, ajaxLogOffUrl and logOnUrl need to be set");
            };
            $(document).bind("mousemove", updateLastActivityDate);
            $(document).bind("keydown", updateLastActivityDate);

            startCheckActivity();
            sendStopCountDownSignalToOtherWindows();

            // Listen to other window storage event 
            // IMPORTANT: Will not work with IE8 because the 'storage' event is sent to document object 
            // but we cannot retrieve impacted key and value.
            $(window).bind('storage', receiveSignalFromOtherWindows);
        },

        stopCounter: function () {
            pingServer();
            stopCountDown();
            startCheckActivity();
            sendStopCountDownSignalToOtherWindows();
        },

        logOn: function () {
            document.location = logOnUrl;
        },

        keepAlive: function () {
            if (
                keepAliveDelay === 0
                || ajaxPingUrl === ""
            ) {
                alert("[ERROR] keepAliveDelay and ajaxPingUrl need to be set");
            };
            setTimeout(keepAliveProcess, keepAliveDelay);
        }
    };
})();